"use strict";var c=Object.defineProperty;var r=(e,a)=>c(e,"name",{value:a,configurable:!0});function l(e,a){const i=[];let t=e;for(;t!=null&&t.kind;)i.push(t),t=t.prevState;for(let o=i.length-1;o>=0;o--)a(i[o])}r(l,"forEachState");exports.forEachState=l;
//# sourceMappingURL=forEachState.cjs.js.map
